import MedicalCheckGreeting from './MedicalCheckGreeting';

export default MedicalCheckGreeting;
